<app-slide-in-modal size="lg" #modal>
  <ng-container title i18n>Contrat existant</ng-container>
  <div body>
    <form
      [formGroup]="existingContracts"
      (ngSubmit)="_AddContractSubmit()"
      class="lty-form"
      [id]="formId"
    >
      <div class="modal-body">
        <div class="split-form-body">
          <div class="form-group flex-basis-50">
            <label i18n>Policy No <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="policyId"
            />
            <div
              *ngIf="
                contractError['policyId'].invalid &&
                (contractError['policyId'].dirty ||
                  contractError['policyId'].touched)
              "
              class="invalid"
            >
              <div *ngIf="contractError['policyId'].errors?.['required']" i18n>
                This Field is required.
              </div>
            </div>
          </div>
          <div class="form-group flex-basis-50">
            <label i18n>Periodicity <span class="text-danger">*</span></label>
            <div class="position-relative">
              <select class="form-control" formControlName="periodicity">
                <option value="" i18n>Select Periodicity</option>
                <option
                  *ngFor="let value of Periodicity"
                  [ngValue]="value"
                  i18n
                >
                  {{ getPeriodicityLabel(value) }}
                </option>
              </select>
              <i class="bi bi-chevron-down edge-element"></i>
              <div
                *ngIf="
                  contractError['premiumAmount'].invalid &&
                  (contractError['premiumAmount'].dirty ||
                    contractError['premiumAmount'].touched)
                "
                class="invalid"
              >
                <div
                  *ngIf="contractError['premiumAmount'].errors?.['required']"
                  i18n
                >
                  This Field is required.
                </div>
              </div>
            </div>
          </div>
          <div class="form-group flex-basis-100">
            <label i18n
              >Type of insurance <span class="text-danger">*</span></label
            >
            <div class="position-relative">
              <select class="form-control" formControlName="insuranceType">
                <option value="" i18n>Select Insurance Type</option>
                <option
                  *ngFor="let product of insuranceTypeList"
                  [value]="product"
                >
                  {{ getInsuranceTypeLabel(product) }}
                </option>
              </select>
              <i class="bi bi-chevron-down edge-element"></i>
              <div
                *ngIf="
                  contractError['insuranceType'].invalid &&
                  (contractError['insuranceType'].dirty ||
                    contractError['insuranceType'].touched)
                "
                class="invalid"
              >
                <div
                  *ngIf="contractError['insuranceType'].errors?.['required']"
                  i18n
                >
                  This Field is required.
                </div>
              </div>
            </div>
          </div>
          <app-product-selection
            #productSelection
            [insurer]="insurer"
            [insuranceType]="existingContracts.controls.insuranceType.value"
            [productForm]="existingContracts"
          />

          <div class="form-group flex-basis-100">
            <label i18n>Périodicité des couvertures sur document</label>
            <div class="position-relative">
              <select class="form-control" formControlName="coversPeriodicity">
                <option
                  *ngFor="let value of Periodicity"
                  [ngValue]="value"
                  i18n
                >
                  {{ getPeriodicityLabel(value) }}
                </option>
              </select>
              <i class="bi bi-chevron-down edge-element"></i>
            </div>
          </div>

          <div class="form-group flex-basis-50">
            <label i18n>Partner Name</label>
            <div class="position-relative">
              <select
                class="form-control"
                formControlName="partnerId"
                (change)="getAgentList()"
              >
                <option value="" i18n>Select Partner</option>
                <option
                  *ngFor="let partner of all_PartnerList"
                  [value]="partner.partnerId"
                >
                  {{ partner.firstName + ' ' + partner.lastName }}
                </option>
              </select>
              <i class="bi bi-chevron-down edge-element"></i>
            </div>
          </div>
          <div class="form-group flex-basis-50">
            <label i18n>Agent Name</label>
            <div class="position-relative">
              <select class="form-control" formControlName="agentId">
                <option value="">Select Agent</option>
                <option
                  *ngFor="let partner of all_AgentList"
                  [ngValue]="partner.partnerId"
                >
                  {{ partner.firstName + ' ' + partner.lastName }}
                </option>
              </select>
              <i class="bi bi-chevron-down edge-element"></i>
            </div>
          </div>
          <div class="form-group flex-basis-50">
            <label i18n>Total Amount <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="totalAmount"
            />
            <div
              *ngIf="
                contractError['totalAmount'].invalid &&
                (contractError['totalAmount'].dirty ||
                  contractError['totalAmount'].touched)
              "
              class="invalid"
            >
              <div
                *ngIf="contractError['totalAmount'].errors?.['required']"
                i18n
              >
                This Field is required.
              </div>
            </div>
          </div>
          <div class="form-group flex-basis-50">
            <label i18n
              >Premium Amount <span class="text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control"
              formControlName="premiumAmount"
            />
            <div
              *ngIf="
                contractError['premiumAmount'].invalid &&
                (contractError['premiumAmount'].dirty ||
                  contractError['premiumAmount'].touched)
              "
              class="invalid"
            >
              <div
                *ngIf="contractError['premiumAmount'].errors?.['required']"
                i18n
              >
                This Field is required.
              </div>
            </div>
          </div>
          <div class="form-group flex-basis-50">
            <label i18n>Start Date <span class="text-danger">*</span></label>
            <div>
              <input
                type="date"
                class="form-control"
                formControlName="startDate"
              />
              <div
                *ngIf="
                  contractError['startDate'].invalid &&
                  (contractError['startDate'].dirty ||
                    contractError['startDate'].touched)
                "
                class="invalid"
              >
                <div
                  *ngIf="contractError['startDate'].errors?.['required']"
                  i18n
                >
                  This Field is required.
                </div>
              </div>
            </div>
          </div>
          <div class="form-group flex-basis-50">
            <label i18n>End Date <span class="text-danger">*</span></label>
            <div>
              <input
                type="date"
                class="form-control"
                min="{{ existingContracts.value.startDate }}"
                formControlName="endDate"
              />
              <div
                *ngIf="
                  contractError['endDate'].invalid &&
                  (contractError['endDate'].dirty ||
                    contractError['endDate'].touched)
                "
                class="invalid"
              >
                <div *ngIf="contractError['endDate'].errors?.['required']" i18n>
                  This Field is required.
                </div>
                <div
                  *ngIf="contractError['endDate'].errors?.['dateAfter']"
                  i18n
                >
                  La date de fin ne peut pas être avant la date de début.
                </div>
              </div>
            </div>
          </div>
          @if (!isCompanyCustomer) {
            <div class="form-group flex-basis-50">
              <label i18n
                >Membre de famille <span class="text-danger">*</span></label
              >

              <mat-form-field class="lty-input">
                <mat-select
                  formControlName="familyMemberId"
                  #singleCustomerSelect
                >
                  <mat-option
                    *ngFor="let member of familyMembers"
                    [value]="member.familyMemberId"
                    >{{ member.firstName + ' ' + member.lastName }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
          }
          <div class="form-group flex-basis-100">
            <label class="file-label" i18n
              >Téléchargez le document de la police</label
            >
            <div class="file alternate">
              <input
                type="file"
                accept=".png, .jpg, .jpeg, .docx, .pdf"
                #fileInput
                (change)="onDocumentUpload($event)"
                multiple
              />
              <div class="upload-icon">
                <app-upload-cloud-icon
                  height="20px"
                  width="20px"
                  color="var(--gray-600)"
                />
              </div>
              <span
                ><span class="highlighted-text" i18n
                  >Cliquez pour télécharger
                </span>
                <ng-container i18n>ou glissez un fichier</ng-container></span
              >
            </div>
            <div *ngIf="policyFiles && policyFiles.length > 0" class="mt-28">
              <span class="mb-16 file-label" i18n>Documents téléchargés</span>
              <div
                class="uploaded-file-container mb-8"
                *ngFor="let uploadedFile of policyFiles; let i = index"
              >
                <div class="uploaded-file-element">
                  <app-file-icon
                    height="20px"
                    width="20px"
                    color="var(--gray-400)"
                  />
                  <div class="file-name">
                    <span>{{ uploadedFile.name }}</span>
                    <span>{{ uploadedFile.size | fileSize: 1 }}</span>
                  </div>
                  <app-check-circle-icon
                    height="16px"
                    width="16px"
                    color="var(--success-500)"
                  />
                </div>
                <app-trash-icon
                  class="clickable"
                  (click)="removeFile(i)"
                  height="24px"
                  width="24px"
                  color="var(--gray-400)"
                />
              </div>
            </div>
          </div>
          <div class="form-group flex-basis-100">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                [value]="true"
                id="handledByLTY"
                formControlName="managedByLty"
              />
              <label class="form-check-label" for="handledByLTY">
                Géré par LTY
              </label>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-submit-buttons" footer>
    <button
      type="button"
      class="lty-btn lty-btn-white ms-auto"
      (click)="closeModal()"
      [disabled]="submitted"
      i18n
    >
      Annuler
    </button>
    <button
      [attr.form]="formId"
      type="submit"
      [disabled]="
        !existingContracts.valid ||
        !policyFiles ||
        policyFiles.length === 0 ||
        submitted
      "
      class="lty-btn lty-btn-primary"
      i18n
    >
      Ajouter
    </button>
  </div>
</app-slide-in-modal>
